<template lang="pug">
  #program-customization-logo
    ContentLoader(:width="300" :height="120" v-if="!programLoaded")
      rect(x="25%", y="0", rx="4", ry="4", width="50%", height="100")
    .is-flex.is-flex-direction-column(v-else)
    .columns.is-justify-content-center
      .column.is-one-third(v-if="programLoaded")
        WtActionMenu#program-logo-action-menu(v-if="currentImage")
          WtActionMenuItem#delete-program-icon.has-text-danger(
            icon="delete"
            text="Remove Image"
            @click.native="destroyProgramLogo()"
          )
        BField
          WtUploadImage(
            entity="program"
            :currentImage.sync="currentImage"
            @updateImage="newLogo = $event"
            @saveImage="uploadLogo"
            show-save
            :loading="uploadInProgress"
          )
            template(v-slot:label)
              WtLabel(isLabelElement text="Upload Your Logo")
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { ContentLoader } from "vue-content-loader";
import programSettingsFormMixin from "@/mixins/programSettingsFormMixin";
import WtUploadImage from "@@/WtUploadImage/WtUploadImage";
import WtLabel from "@@/WtLabel/WtLabel";
import WtActionMenu from "@@/WtActionMenu/WtActionMenu";
import WtActionMenuItem from "@@/WtActionMenuItem/WtActionMenuItem";

export default {
  name: "ProgramCustomizationLogo",

  components: {
    WtLabel,
    ContentLoader,
    WtUploadImage,
    WtActionMenu,
    WtActionMenuItem
  },

  mixins: [programSettingsFormMixin],

  data() {
    return {
      currentImage: null,
      newLogo: null,
      uploadInProgress: false
    };
  },

  computed: {
    ...mapGetters("program", ["programSettingsCopy", "programLoaded"])
  },

  mounted() {
    this.currentImage = this._.get(
      this.programSettingsCopy,
      "programLogo",
      require("@/assets/icons/logo.svg")
    );
  },

  methods: {
    ...mapActions("program", [
      "updateCoreMeta",
      "updateProgramSettingsCopy",
      "programSettingsUpdate"
    ]),

    ...mapActions(["snackBar"]),

    async uploadLogo() {
      const formData = new FormData();
      this.uploadInProgress = true;

      formData.set("programLogo", this.newLogo);

      const uploadResponse = await this.programSettingsUpdate({
        programId: this.$auth.user().programId,
        formData
      });
      if (uploadResponse.error) {
        if (
          uploadResponse.error.code === "validation_failed" &&
          this._.has(uploadResponse, "error.fields.image")
        ) {
          this.snackBar({
            type: "is-danger",
            duration: 10000,
            queue: false,
            message: uploadResponse.error.fields.image[0]
          });
        } else {
          this.snackBar({
            type: "is-danger",
            duration: 10000,
            queue: false,
            message: `There was an error processing your image.
                        Please try again. Or please reach out to wellness@be-engaged.co.`
          });
        }
        this.uploadInProgress = false;
      } else {
        const programLogo = uploadResponse.data.data.programLogo;
        this.updateCoreMeta({
          key: "programLogo",
          value: programLogo
        });
        this.updateProgramSettingsCopy({
          key: "programLogo",
          value: programLogo
        });
        this.snackBar({ message: "Your logo has been updated." });
      }
      this.uploadInProgress = false;
    },

    async destroyProgramLogo() {
      try {
        let response = await this.axios.delete(
          `programs/${this.$auth.user().programId}/delete-icon`
        );
        const programLogo = response.data.data.programLogo;
        this.currentImage = programLogo;
        this.updateCoreMeta({
          key: "programLogo",
          value: programLogo
        });
        this.updateProgramSettingsCopy({
          key: "programLogo",
          value: programLogo
        });
        this.snackBar({ message: "Your logo has been removed." });
      } catch (error) {
        this.snackBar({
          type: "is-danger",
          duration: 10000,
          queue: false,
          message: `There was an error processing your image.
                        Please try again. Or please reach out to wellness@be-engaged.co.`
        });
      }
    }
  }
};
</script>

<style lang="sass">
#program-customization-logo
  position: relative
  #program-logo-action-menu
    position: absolute
    top: 0
    right: 0
</style>
